import * as React from 'react'
import {MapContainer, Marker, Popup, TileLayer, useMapEvents} from "react-leaflet";
import {useSelector} from "react-redux";


function Neshan(props) {
  const selector = useSelector((st) => st)
  const [zoom, setZoom] = React.useState(null);

  const MapEvents = () => {
    useMapEvents({
      click(e) {
        setZoom(e?.target?._zoom)
        props.setLngLat({
          lngLat: {
            lng: e?.latlng?.lng,
            lat: e?.latlng?.lat
          }
        })
        props.mapObject.flyTo([e?.latlng?.lat, e?.latlng?.lng], props?.zoom)
        props.handlerSearchWithLocation(e?.latlng?.lng, e?.latlng?.lat)
      },
    });
    return false;
  }

  return (
     <MapContainer
        id="neshanMap"
        center={[props?.latToMap || props?.coordinates[0]?.pointX || 35.7, props?.lngToMap || props?.coordinates[0]?.pointY || 51.4]}
        zoom={zoom || props?.zoom}
        style={{height: "300px", width: "100%"}}
        ref={props?.setMapObject}
     >
       <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution=''
       />

       <MapEvents/>

       {
         props?.coordinates?.map((item, index) =>
            <Marker position={[item?.pointX || props?.latToMap || 35.7, item?.pointY || props?.lngToMap || 51.4]}>
              <Popup>
                {(item?.pointX || props?.latToMap || 35.7) + ' ' + (item?.pointY || props?.lngToMap || 51.4)}
              </Popup>
            </Marker>
         )
       }
     </MapContainer>
  );
}


export default Neshan
